import { cn } from '@/lib/utils';

type Props = {
  'aria-label': string;
  options: { value: string; label: string }[];
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
};

export function SegmentedControl({
  'aria-label': ariaLabel,
  options,
  value,
  onChange,
  disabled,
}: Props) {
  return (
    <div
      role='group'
      aria-label={ariaLabel}
      className={cn(
        'flex gap-0.5 p-0.5 rounded-lg bg-muted/40 border border-border/30',
        disabled && 'opacity-40'
      )}
    >
      {options.map((option) => (
        <button
          key={option.value}
          type='button'
          disabled={disabled}
          aria-pressed={value === option.value}
          onClick={() => onChange(option.value)}
          className={cn(
            'flex-1 text-[11px] px-1.5 py-2.5 rounded font-medium transition-colors leading-tight disabled:cursor-not-allowed',
            value === option.value
              ? 'bg-background shadow-sm text-foreground'
              : 'text-muted-foreground enabled:hover:text-foreground'
          )}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
